import PropTypes from 'prop-types'
import { kea } from 'kea'
import DataLogic from 'containers/App/logic'

export default kea({

  // Rename store
  path: () => (['scenes', 'equipments']),

  // Connect to app logic for the needed values
  connect: {
    actions: [
      DataLogic, ['setValue', 'setValues']
    ],
    props: [
      DataLogic, ['values', 'offerType', 'offerTypes', 'translations']
    ]
  },

  // All actions
  actions: () => ({
    // Toggles
    toggleEquipmentsModal: (offerType) => ({ offerType }),
    toggleEquipmentsEditModal: (equipment) => ({ equipment }),

    // Sets
    setDivision: (division) => ({ division }),
    setStartDivisions: (divisions) => ({ divisions }),
    setNewClassId: (id) => ({ id }),
    setEquipment: (division, equipment) => ({ division, equipment }),

    // Openers
    openEquipmentsList: () => ({}),
    closeEquipmentsList: () => ({})
  }),

  reducers: ({ actions }) => ({

    // Current division of the user
    currentDivision: [null, PropTypes.object, {
      [actions.setDivision]: (state, payload) => payload.division
    }],

    // If the right equipments modal is opened or not
    equipmentsOpened: [false, PropTypes.any, {
      [actions.toggleEquipmentsModal]: (state, payload) => !state
    }],

    // If the edit modal is opened or not
    modalOpened: [false, PropTypes.any, {
      [actions.toggleEquipmentsEditModal]: (state, payload) => payload.equipment
    }],

    // Unused i guess
    newClassId: [null, PropTypes.any, {
      [actions.setNewClassId]: (state, payload) => payload.id
    }],

    // The current equipments offer type
    equipmentsOfferType: [null, PropTypes.any, {
      [actions.toggleEquipmentsModal]: (state, payload) => payload.offerType
    }],

    // Determiner if the equipments list is shown or not
    showEquipmentsList: [false, PropTypes.bool, {
      [actions.openEquipmentsList]: () => true,
      [actions.closeEquipmentsList]: () => false
    }]
  })
})



// WEBPACK FOOTER //
// ./src/containers/Equipments/logic.js